import React from "react";
import { ErrorMessage, Field, Form, Formik } from "formik";
import * as Yup from "yup";
import { Col, Collapse, Row } from "antd";
import { useTranslation } from "react-i18next";
import { API_CREATE_EMAIL_TEMPLATE } from "api/email";
import { useLocation, useNavigate } from "react-router-dom";
function CreateEmailTemplate() {
  const { t } = useTranslation();
  const Navigate = useNavigate();
  const location = useLocation();
  

  return (
    <div className="flex min-w-[100%] flex-col gap-5 rounded-2xl border-[1px] bg-white p-12  shadow-md">
      <div className="">
        <Formik
          enableReinitialize
          initialValues={{
            template_name: "",
            description: "",
          }}
          validationSchema={Yup.object({
            template_name: Yup.string().required("Required"),
            description: Yup.string().required("Required"),
          })}
          onSubmit={async (values, { setSubmitting, setFieldError }) => {
            try {
              const { template_name, description } = values;
              const payload = {
                template_name: template_name,
                description: description,
              };
              const res = await API_CREATE_EMAIL_TEMPLATE(payload);
              if(res){
                Navigate("/admin/email/list-email-template");
              }
            } catch (err) {}
          }}
        >
          {({ isSubmitting, values, setFieldValue }) => (
            <Form>
              <Row gutter={[16, 16]}>
                <Col span={8}>
                  <div className="flex flex-col">
                    <label className="font-bold">{t("Template Name")}</label>
                    <Field
                      className="mt-2 flex h-11 w-full items-center justify-center rounded-xl border bg-white p-3 text-sm outline-none"
                      type="text"
                      name="template_name"
                      placeholder={t("Template Name")}/>
                    <ErrorMessage
                      name="template_name"
                      component="div"
                      className="text-red-500"
                    />
                  </div>
                </Col>
                <Col span={8}>
                  <div className="flex flex-col">
                    <label className="font-bold">{t("Description")}</label>
                    <Field
                      className="mt-2 flex h-11 w-full items-center justify-center rounded-xl border bg-white p-3 text-sm outline-none"
                      type="text"
                      name="description"
                      placeholder={t("Description")}
                    />
                    <ErrorMessage
                      name="description"
                      component="div"
                      className="text-red-500"
                    />
                  </div>
                </Col>
              </Row>
              <Row gutter={[16, 16]}>
                <Col span={24}>
                  <button
                    type="submit"
                    disabled={isSubmitting}
                    className="linear p-[4px 11px] ml-auto  mt-8 flex w-full max-w-[9rem] cursor-pointer items-center justify-center rounded-xl bg-brand-500 py-2 text-center text-base font-medium text-white transition duration-200 hover:bg-white  hover:text-brand-500 dark:bg-brand-400 dark:text-white dark:active:bg-brand-200"
                  >
                    {isSubmitting ? t("Creating template") + "..." : t("Create template")}
                  </button>
                </Col>
              </Row>
            </Form>
          )}
        </Formik>
      </div>
    </div>
  );
}

export default CreateEmailTemplate;






